import React from "react";
import { Helmet } from "react-helmet-async";
import { Stack } from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

import PageHeader from "../../../components/pages/_new/super/common/PageHeader";
import {
  SectionCard,
  EmptyState,
} from "../../../components/pages/_new/super/design";

function SADataRetention() {
  return (
    <React.Fragment>
      <Helmet title="SA Data Retention" />
      <PageHeader
        title="Data Retention"
        description="Per-category retention windows for events and logs"
      />
      <Stack spacing={2}>
        <SectionCard
          title="Retention controls"
          description="Configure how long observability and event data is retained"
        >
          <EmptyState
            icon={<HourglassEmptyIcon />}
            title="Data retention controls coming soon"
            body="Per-category retention sliders (BM events, WAF events, API security audit, DLP audit, DDoS verdicts) will be configurable here. Today retention is driven by ClickHouse TTL clauses."
          />
        </SectionCard>
      </Stack>
    </React.Fragment>
  );
}
export default SADataRetention;
